import { ADULTS_DEFAULT, CHILDREN_DEFAULT, TRANSPORT_DEFAULT, CHARTERS_DIRECTION_BOTH_WAY } from '../consts/data'
import {
    SET_END_DATE,
    SET_START_DATE,
    SET_TRANSPORT,
    TOGGLE_LAST_MINUTE,
    TOGGLE_ALL_INCLUSIVE,
    SET_LAST_MINUTE,
    SET_DESTINATIONS,
    SET_DEPARTURES,
    REMOVE_DEPARTURE,
    SET_ADULTS,
    SET_CHILDREN_AGE,
    TOGGLE_SELECTION,
    RESET_SELECTION_FIELD,
    RESET_PARTICIPANTS,
    SET_FORM_FIELD,
    SET_HOTEL,
    SET_TRIP_DIRECTION
} from '../actions/formActions'

const today = new Date()
const tommorow = new Date(today)
tommorow.setDate(today.getDate() + 1);
const defaultDate = tommorow.toISOString().split('T')[0];

const initialState = {
    transport: null,
    kierunek: '',
    cities: [],
    z: '',
    od: defaultDate,
    do: '',
    dorosli: ADULTS_DEFAULT,
    dzieci: CHILDREN_DEFAULT,
    lastMinute: false,
    allInclusive: false,
    tripDirection: CHARTERS_DIRECTION_BOTH_WAY,
    hotel: ''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_TRANSPORT:
            return { ...state, transport: action.payload }
        case SET_START_DATE:
            return { ...state, od: action.payload }
        case SET_END_DATE:
            return { ...state, do: action.payload }
        case TOGGLE_LAST_MINUTE:
            return { ...state, lastMinute: !state.lastMinute }
        case SET_LAST_MINUTE:
            return { ...state, lastMinute: action.payload }
        case TOGGLE_ALL_INCLUSIVE:
            return { ...state, allInclusive: !state.allInclusive }
        case SET_TRIP_DIRECTION:
            return { ...state, tripDirection: action.payload }
        case SET_DESTINATIONS:
            return { ...state, kierunek: action.destinations }
        case TOGGLE_SELECTION:
            const { field, value } = action.payload;
            const current = state[field] ? state[field].split(';') : [];

            const exists = current.includes(value);
            const updated = exists
                ? current.filter(item => item !== value)
                : [...current, value];

            return {
                ...state,
                [field]: updated.join(';'),
            };

        case RESET_SELECTION_FIELD: {
            const { field } = action.payload;

            return {
                ...state,
                [field]: initialState[field],
                ...(field === 'kierunek' ? { cities: [] } : {}),
            };
        }

        case SET_DEPARTURES:
            return { ...state, z: action.payload }
        case REMOVE_DEPARTURE:
            return {
                ...state,
                z: state.z.filter(item => item !== action.payload)
            }
        case SET_ADULTS:
            return { ...state, dorosli: action.payload }
        case SET_CHILDREN_AGE:
            return {
                ...state,
                dzieci: action.payload
            }
        case RESET_PARTICIPANTS:
            return {
                ...state,
                dorosli: ADULTS_DEFAULT,
                dzieci: CHILDREN_DEFAULT
            }
        case SET_FORM_FIELD:
            const rawValue = action.payload.value;
            const val = action.payload.key === 'dzieci'
                ? (String(rawValue).trim() === ''
                    ? []
                    : String(rawValue).split(',').map(age => parseInt(age.trim(), 10)))
                : rawValue;

            return {
                ...state,
                [action.payload.key]: val
            }
        case SET_HOTEL:
            return {
                ...state,
                hotel: action.payload || ''
            }
        default:
            return state
    }
}
